(() => {
  'use strict';
  if (window.UniImagePriority) return;
  const pending = new Map();
  const states = new WeakMap();
  const activate = container => {
    const template = pending.get(container);
    if (!template || !template.isConnected) return;
    const state = states.get(container);
    if (container.closest?.('[data-uni-primary-gate]') && !state.ready) {
      if (!state.waiting) {
        state.waiting = true;
        state.cancel = whenPrimaryReady(() => {
          state.ready = true;
          if (state.near) activate(container);
        });
      }
      return;
    }
    pending.delete(container);
    state.cancel?.();
    observer?.unobserve(container);
    const content = template.content.cloneNode(true);
    content.querySelectorAll('img').forEach(image => {
      image.loading = 'eager';
    });
    template.replaceWith(content);
  };
  let pageLoaded = document.readyState === 'complete';
  let observer = null;
  function createObserver(rootMargin) {
    if (typeof window.IntersectionObserver !== 'function') return null;
    const nextObserver = new IntersectionObserver(entries => {
      if (observer !== nextObserver) return;
      entries.forEach(entry => {
        const state = states.get(entry.target);
        if (!state) return;
        state.near = entry.isIntersecting;
        if (entry.isIntersecting) activate(entry.target);
      });
    }, { rootMargin });
    return nextObserver;
  }
  observer = createObserver(pageLoaded ? '600px 0px' : '0px');
  function expandObserver() {
    if (pageLoaded) return;
    pageLoaded = true;
    if (!observer) return;
    observer.disconnect();
    observer = createObserver('600px 0px');
    pending.forEach((template, container) => {
      const state = states.get(container);
      if (!template.isConnected) {
        state?.cancel?.();
        pending.delete(container);
        return;
      }
      if (state) state.near = false;
      observer.observe(container);
    });
  }
  if (!pageLoaded) window.addEventListener('load', expandObserver, { once: true });
  function init(scope = document) {
    pending.forEach((template, container) => {
      if (!template.isConnected) { states.get(container)?.cancel?.(); observer?.unobserve(container); pending.delete(container); }
    });
    const templates = [...scope.querySelectorAll('template[data-uni-deferred-image]')];
    if (scope.matches?.('template[data-uni-deferred-image]')) templates.unshift(scope);
    templates.forEach(template => {
      const container = template.parentElement;
      if (!container || pending.has(container)) return;
      pending.set(container, template);
      states.set(container, { near: !observer, ready: false, waiting: false, cancel: null });
      if (observer) observer.observe(container);
      else activate(container);
    });
  }
  function whenPrimaryReady(callback) {
    const primary = document.querySelector('[data-uni-main-image]');
    let done = false;
    const cleanup = () => {
      primary?.removeEventListener('load', loaded);
      primary?.removeEventListener('error', finish);
      document.removeEventListener('uni:hero-ready', ready);
      document.removeEventListener('uni:hero-error', ready);
    };
    const finish = () => {
      if (done) return;
      done = true;
      cleanup();
      callback();
    };
    const ready = event => { if (!primary || event.target === primary || ['ready', 'error'].includes(primary.dataset.uniImageState)) finish(); };
    const loaded = () => { if (!primary.dataset.uniImageState || primary.dataset.uniImageState === 'ready') finish(); };
    if (!primary || ['ready', 'error'].includes(primary.dataset.uniImageState) || (!primary.dataset.uniImageState && primary.complete && primary.naturalWidth)) finish();
    else {
      primary.addEventListener('load', loaded);
      primary.addEventListener('error', finish);
      document.addEventListener('uni:hero-ready', ready);
      document.addEventListener('uni:hero-error', ready);
    }
    return () => { done = true; cleanup(); };
  }
  window.UniImagePriority = { init, whenPrimaryReady };
  const start = () => {
    init();
    if (typeof MutationObserver === 'function') {
      new MutationObserver(records => {
        records.forEach(record => record.addedNodes.forEach(node => {
          if (node.nodeType === 1) init(node);
        }));
        pending.forEach((template, container) => {
          if (!template.isConnected) { states.get(container)?.cancel?.(); observer?.unobserve(container); pending.delete(container); }
        });
      }).observe(document.body, { childList: true, subtree: true });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
